import { api } from './api'


class ClientInvitationAPI {

  public async create(namespaceId: string, data: { email: string }) {
    await api.post('/client-invitations', {
      namespace: namespaceId,
      email: data.email
    })
  }
}

export const clientInvitationAPI = new ClientInvitationAPI()
